export const APPLY_BUTTON_STYLE = {
  backgroundColor: "#003366",
  color: "#FFFFFF",
  border: "none",
  fontWeight: 600,
  padding: "8px 24px",
  borderRadius: "6px",
  fontSize: "14px",
};

export const RESET_BUTTON_STYLE = {
  backgroundColor: "#FDE8E8",
  color: "#8B1A1A",
  border: "none",
  fontWeight: 600,
  padding: "8px 24px",
  borderRadius: "6px",
  fontSize: "14px",
};

export const PAGINATION_COLORS = {
  navy: "#003366",
  textMuted: "#6B7280",
  border: "#E0E0E0",
};

const padDateTimeUnit = (value) => String(value).padStart(2, "0");

export const getTodayStartDateTime = () => {
  const now = new Date();
  return `${now.getFullYear()}-${padDateTimeUnit(now.getMonth() + 1)}-${padDateTimeUnit(now.getDate())}T00:00`;
};

export const getTodayEndDateTime = () => {
  const now = new Date();
  return `${now.getFullYear()}-${padDateTimeUnit(now.getMonth() + 1)}-${padDateTimeUnit(now.getDate())}T${padDateTimeUnit(now.getHours())}:${padDateTimeUnit(now.getMinutes())}`;
};

export const VEHICLE_TYPE_OPTIONS = [
  { value: "", label: "Select" },
  { value: "primary2", label: "Primary2" },
  { value: "3wheeler", label: "3 Wheeler" },
];

export const RC_SITE_OPTIONS = [
  { value: "", label: "Select Site" },
  { value: "dump-site", label: "Dump site" },
  { value: "p-and-d", label: "P&D" },
];

export const RC_WASTE_TYPE_OPTIONS = [
  { value: "", label: "Select Waste Type" },
  { value: "waste-1", label: "Waste 1" },
  { value: "waste-2", label: "Waste 2" },
  { value: "waste-3", label: "Waste 3" },
];

export const FCTS_OPTIONS = [
  { value: "", label: "Select FCTS" },
  { value: "fcts-1", label: "Name of the location1" },
  { value: "fcts-2", label: "Name of the location2" },
  { value: "fcts-3", label: "Name of the location3" },
];

export const HOOK_LOADER_FCTS_OPTIONS = [
  { value: "", label: "Select FCTS" },
  { value: "fcts-okhla", label: "Okhla FCTS" },
  { value: "fcts-gazipur", label: "Gazipur FCTS" },
  { value: "fcts-narela", label: "Narela FCTS" },
];

export const HOOK_LOADER_DUMPSITE_OPTIONS = [
  { value: "", label: "Select Dumpsite" },
  { value: "dump-bhalswa", label: "Bhalswa Dumpsite" },
  { value: "dump-gazipur", label: "Gazipur Dumpsite" },
  { value: "dump-okhla", label: "Okhla Dumpsite" },
];

export const filterRowsByCriteria = (rows, filters, options = {}) => {
  const { wardField = "wardId", dateField = "reportDateTime" } = options;

  return rows.filter((row) => {
    if (filters.wardId && String(row[wardField]) !== String(filters.wardId)) {
      return false;
    }

    if (filters.fctsId && row.fctsId !== filters.fctsId) {
      return false;
    }

    if (filters.vehicleType && row.vehicleType !== filters.vehicleType) {
      return false;
    }

    if (filters.siteId && row.siteId !== filters.siteId) {
      return false;
    }

    if (filters.wasteType && row.wasteType !== filters.wasteType) {
      return false;
    }

    if (
      filters.wasteTypeId &&
      String(row.wasteTypeId) !== String(filters.wasteTypeId)
    ) {
      return false;
    }

    if (filters.vehicleNo) {
      const vehicleNo = String(row.vehicleNo ?? "").toLowerCase();
      const searchVehicleNo = String(filters.vehicleNo).trim().toLowerCase();
      if (!vehicleNo.includes(searchVehicleNo)) {
        return false;
      }
    }

    if (filters.dumpsiteId && row.dumpsiteId !== filters.dumpsiteId) {
      return false;
    }

    const rowDateTime = row[dateField] ?? "";

    if (filters.fromDateTime && rowDateTime < filters.fromDateTime) {
      return false;
    }

    if (filters.toDateTime && rowDateTime > filters.toDateTime) {
      return false;
    }

    return true;
  });
};

export const calculateDeploymentPercent = (planned, reached) => {
  if (!planned) return "0%";
  return `${Math.round((reached / planned) * 100)}%`;
};

export const calculateCoveragePercent = (total, cleared) => {
  if (!total) return "0%";
  return `${Math.round((cleared / total) * 100)}%`;
};

export const paginateRows = (rows, page, pageSize) => {
  const start = page * pageSize;
  return rows.slice(start, start + pageSize);
};
